__turbopack_context__.v({
  "list": "ActionPlanObjectiveListCard-module__MhKW5a__list",
  "meta": "ActionPlanObjectiveListCard-module__MhKW5a__meta",
  "row": "ActionPlanObjectiveListCard-module__MhKW5a__row",
  "title": "ActionPlanObjectiveListCard-module__MhKW5a__title",
});
